import axios from 'axios'
import { BASE_URL } from './../../config'
import {
  apiService,
  getCookieValue,
  checkCookieExists,
  validateStudentId,
  validateFiles
} from '../common-services'
import {
  DCR_FORM_CONFIG,
  FEE_COLLECTION_FORM_CONFIG,
  FEE_RECEIPT_FORM_CONFIG,
  FEE_REMINDER_FORM_CONFIG,
  FEE_REPORTS_FORM_CONFIG,
  LATE_FEE,
  LATE_FEE_FORM_CONFIG,
  PAYMODE_COLLECTION_REPORT_FORM_CONFIG,
  PETTY_COLLECTION_FORM_CONFIG,
} from './fee-config-form-config'
import { CLASS_LIST, FEE_HEADS_LIST, SECTION_LIST, SESSION_LIST, STUDENT_LIST } from './fee-data'

// Function to get student details by student ID using POST method
export const getStudentDetails = async (studentId, additionalData = {}, files = []) => {
  try {
    // Step 1: Validate the provided student ID
    validateStudentId(studentId) // Check if the student ID is valid

    // Step 2: Check if the School_Code cookie exists
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!') // Throw error if cookie is not found
    }

    const schoolCode = getCookieValue('School_Code') // Step 3: Get the school code from the cookie

    // Step 4: Validate files if any are provided
    if (files.length > 0) {
      validateFiles(files) // Validate the files for size and type
    }

    // Step 5: Create FormData object to handle file uploads
    const formData = new FormData()
    formData.append('studentId', studentId) // Step 6: Add the student ID to FormData
    formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData

    // Step 8: Append additional data (if any) to FormData
    Object.keys(additionalData).forEach((key) => {
      if (additionalData[key]) {
        // Step 9: Only append if the value is not empty/null
        formData.append(key, additionalData[key]) // Add additional data to FormData
      }
    })

    // Step 10: Append files (if any) to FormData
    files.forEach((file, index) => {
      formData.append(`documents[${index}]`, file) // Step 11: Append each file with a unique name
    })

    // Step 12: Call the API service using POST method
    const response = await apiService(`${BASE_URL}/api-controller/student/details`, 'POST', formData, {
      'Content-Type': 'multipart/form-data', // Step 13: Specify content type for form data
    })

    return response // Step 14: Return the response from the API
  } catch (error) {
    console.error('Error fetching student details:', error) // Step 15: Log any errors
    throw error // Step 16: Re-throw the error to be handled by the calling function
  }
}

// Function to get fee details by student ID using POST method
export const getFeeDetails = async (studentId, additionalData = {}, files = []) => {
  try {
    // Step 1: Validate the provided student ID
    validateStudentId(studentId) // Check if the student ID is valid

    // Step 2: Check if the School_Code cookie exists
    if (!checkCookieExists('School_Code')) {
      throw new Error('School_Code cookie not found!') // Throw error if cookie is not found
    }

    const schoolCode = getCookieValue('School_Code') // Step 3: Get the school code from the cookie

    // Step 4: Validate files if any are provided
    if (files.length > 0) {
      validateFiles(files) // Validate the files for size and type
    }

    // Step 5: Create FormData object to handle file uploads
    const formData = new FormData()
    formData.append('studentId', studentId) // Step 6: Add the student ID to FormData
    formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData

    // Step 8: Append additional data (if any) to FormData
    Object.keys(additionalData).forEach((key) => {
      if (additionalData[key]) {
        // Step 9: Only append if the value is not empty/null
        formData.append(key, additionalData[key]) // Add additional data to FormData
      }
    })

    // Step 10: Append files (if any) to FormData
    files.forEach((file, index) => {
      formData.append(`documents[${index}]`, file) // Step 11: Append each file with a unique name
    })

    // Step 12: Call the API service using POST method
    const response = await apiService(`${BASE_URL}/student/feeDetails`, 'POST', formData, {
      'Content-Type': 'multipart/form-data', // Step 13: Specify content type for form data
    })

    return response // Step 14: Return the response from the API
  } catch (error) {
    console.error('Error fetching fee details:', error) // Step 15: Log any errors
    throw error // Step 16: Re-throw the error to be handled by the calling function
  }
}

export const getSessionDetails = () => {
  return SESSION_LIST
}
export const getClassDetails = () => {
  return CLASS_LIST
}
export const getSectionDetails = () => {
  return SECTION_LIST
}
export const getFeeHEadDetails = () => {
  return FEE_HEADS_LIST
}
export const getStudentList = () => {
  return STUDENT_LIST
}

// getting fee configuration data form configurations
export const getFeeCollectionFormConfig = () => {
  return FEE_COLLECTION_FORM_CONFIG
}
export const getFeeReceiptFormConfig = () => {
  return FEE_RECEIPT_FORM_CONFIG
}
export const getLatFeeFormConfig = () => {
  return LATE_FEE_FORM_CONFIG
}
export const getDCRFormConfig = () => {
  return DCR_FORM_CONFIG
}
export const getPayModeCollectionFormConfig = () => {
  return PAYMODE_COLLECTION_REPORT_FORM_CONFIG
}
export const getFeeReportFormConfig = () => {
  return FEE_REPORTS_FORM_CONFIG
}
export const getFeeReminderReportConfig = () => {
  return FEE_REMINDER_FORM_CONFIG
}
export const getPettyCollectionFormConfig = () => {
  return PETTY_COLLECTION_FORM_CONFIG
}

export const fetchFeeConfigurationFormData = async (data) => {
  try {
    return await axios.post(
      // `${BASE_URL}/FeeConfiguration1.php`,
      `${BASE_URL}/FeeConfiguration1.php&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      data, // Pass the form data here
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee configuration form data', err.message) // Handle errors
  }
}
export const saveFeeConfigurationData = async (data) => {
  try {
    return await axios.post(
      `${BASE_URL}/FeeConfiguration1.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      data, // Pass the form data here
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving fee configuration form data', err.message) // Handle errors
  }
}

export const getAllMasterFeeHeads = async () => {
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?getAllFeeHeads=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, {
      headers: {
        'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
      },
    }) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while fetching master fee heads data', err.message) // Handle errors
  }
}
export const saveNewMasterFeeHeads = async (data) => {
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
      },
    }) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while fetching master fee heads data', err.message) // Handle errors
  }
}
export const updateMasterFeeHeads = async (data) => {
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
      },
    }) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while fetching master fee heads data', err.message) // Handle errors
  }
}

// master account functions
export const saveNewMasterAccount = async (data) => {
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      data, // Pass the form data here
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving fee configuration form data', err.message) // Handle errors
  }
}
export const updateMasterAccounts = async (data) => {
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      data, // Pass the form data here
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving fee configuration form data', err.message) // Handle errors
  }
}
export const blockCollectPermission = async (id) => {
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?disableStaff=1&staffId=${id}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while allowing collect permission', err.message) // Handle errors
  }
}
export const allowCollectPermission = async (id) => {
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?enableStaff=1&staffId=${id}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while allowing collect permission', err.message) // Handle errors
  }
}
export const createCollectPermission = async (data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  data.append('schoolCode', schoolCode)
  data.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php?`, data, {
      headers: {
        'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
      },
    }) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while creating collect permission', err.message) // Handle errors
  }
}


export const addFeeHeads = async (session, feeHead) => {
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&addFeeHead=1&session=${session}&fee_head=${feeHead}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding fee head', err.message) // Handle errors
  }
}

export const createFeeConcession = async (data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  data.append('schoolCode', schoolCode)
  data.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/FeeControlNew_1.php?`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while creating form concession', err.message)
  }
}

export const insertFeeGroup = async (data) => {
  console.log(data)
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&insertFeeGroupCluster=1&cluster_name=${data.cluster_name}&cluster_school_name=${data.cluster_school_name}&fee_stream=${data.fee_stream}&student_type=${data.student_type}&fee_group_type=${data.fee_group_type}&class_names=${data.class_names}`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while adding fee head', err.message) // Handle errors
  }
}

export const delFeeGroup = async (id) => {
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&deleteFeeGroupCluster=1&cluster_class_id=${id}`,
    )
  } catch (err) {
    console.log('Error while deleting', err.message)
  }
}
// common api calls
export const getAllSession = async () => {
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&getSessions=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all sessions', err.message) // Handle errors
  }
}
export const getAllFinancilSession = async () => {
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=swipetouch&getFSessions=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all sessions', err.message) // Handle errors
  }
}

export const getFeeHeadsBySession = async (session) => {
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?getFeeHeadsBySessions=1&session=${session}&LOGINID=swipetouch&schoolCode=${getCookieValue('schoolCode')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all fee heads by session', err.message) // Handle errors
  }
}

export const getAllClasses = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getClasses=1`,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
        },
      },
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting all classes', err.message) // Handle errors
  }
}
export const createFeeStructure = async (data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  data.append('schoolCode', schoolCode)
  data.append('loginId', loginId)
  data.append('responseType','JSON')
  try {
    return await axios.post(`${BASE_URL}/FeeControlNew_1.php`, data)
  } catch (err) {
    console.log('Error while creating fee structure:', err.message)
  }
}

export const postFeeStructure = async (session, group_type) => {
  try {
    return await axios.get(
      `${BASE_URL}/universal_apis.php?get_all_clusters_by_session=1&group_type=${group_type}&session=${session}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee clusters by group type and session', err.message) // Handle errors
  }
}

export const getAccountTypeFeeGroupType = async () => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeCollectionGroupMap_Api.php?get_table_data=1&fee_type_table=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee group type', err.message) // Handle errors
  }
}

export const getMasterAccounts = async (studentid, session, ac_type) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeCollectionNewAPI.php?Parameter=FetchMasterAccount&studentid=${studentid}&session=${session}&ac_type=${ac_type}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee group type', err.message) // Handle errors
  }
}

export const getFeeCollectionData = async (studentid, ac_type, session, pay_date) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeCollectionNewAPI.php?Parameter=CollectFee&studentid=${studentid}&ac_type=${ac_type}&school_id=1&session=${session}&pay_date=${pay_date}&master_account=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee group type', err.message) // Handle errors
  }
}

export const getFeeCollectionData2 = async (studentid, ac_type, session, pay_date, master_account) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeCollectionNewAPI.php?Parameter=CollectFee&studentid=${studentid}&ac_type=${ac_type}&school_id=1&session=${session}&pay_date=${pay_date}&master_account=${master_account}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting fee group type', err.message) // Handle errors
  }
}

export const getPerYearFeeDetails = async (studentid, ac_type, session, pay_date) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeCollectionNewAPI.php?Parameter=PY_FEE_DETAILS&studentid=${studentid}&ac_type=${ac_type}&school_id=1&session=${session}&pay_date=${pay_date}&master_account=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting per yearfee details', err.message) // Handle errors
  }
}

export const getFeeConcessionDetails = async (concession_id) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeControlNew_1.php?get_consessions=1&concession_id=${concession_id}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting concession details', err.message) // Handle errors
  }
}
export const getMonthWiseFeeHeadData = async (studentid, session, selected_mons, ac_type) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeInstallmentDetailsAPI.php?studentid=${studentid}&selected_mons=${selected_mons}&session=${session}&ac_type=${ac_type}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting month wise fee head details', err.message) // Handle errors
  }
}
export const getFeesSummary = async (studentid, session) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeCollectionNewAPI.php?Parameter=ViewFeeSummary&studentid=${studentid}&session=${session}&&school_id=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting month wise fee head details', err.message) // Handle errors
  }
}
export const getFeeRecieptDetails = async (studentid, session) => {
  try {
    return await axios.get(
      `${BASE_URL}/UnniversalAppAPI.php?get_fee_receipt=getallreceipts&student_id=${studentid}&session=${session}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting reciept details', err.message) // Handle errors
  }
}
export const cancelFeesReceipt = async (receipt_id, cancel_remarks) => {
  try {
    return await axios.get(
      `${BASE_URL}/FeeCancelReceiptControllerNew.php?receipt_id=${receipt_id}&cancel_remarks=${cancel_remarks}&master_account=1&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while canceling fee receipt', err.message) // Handle errors
  }
}
export const makePayment = async (paymentData) => {
  try {
    return await axios.post(`${BASE_URL}/FeeCollectionNew2.php?&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, paymentData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Adjust header based on API requirements
      },
    }) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while making payment', err.message) // Handle errors
  }
}

export const approveOnlinePaymentSettlement = async () => { }
export const getAllAvailableMasterAccounts = async (data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getMasterAccounts=1`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving fee configuration form data', err.message) // Handle errors
  }
}
export const getAllOnlineSettelementTransactions = async (
  gateway_type,
  Master_Account,
  search_date_type,
  fdate,
  tdate,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const formData = new FormData()
  formData.append('gateway_type', gateway_type)
  formData.append('Master_Account', Master_Account)
  formData.append('search_date_type', search_date_type)
  formData.append('fdate', fdate)
  formData.append('tdate', tdate)
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)
  formData.append('get_online_payment_settlement_transaction', 1)
  try {
    return await axios.post(
      // `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getMasterAccounts=1`,
      `${BASE_URL}/GetOnlinePaymentAPI1.php`,
      formData,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving fee configuration form data', err.message) // Handle errors
  }
}
export const reconcileOnlinePaymentTransactions = async (
  gateway_type,
  Master_Account,
  fdate,
  tdate,
  selected_transaction,
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const formData = new FormData()
  formData.append('gateway_type', gateway_type)
  formData.append('Master_Account', Master_Account)
  formData.append('selected_transaction', selected_transaction)
  formData.append('fdate', fdate)
  formData.append('tdate', tdate)
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)
  formData.append('update_settlement_data', 1)
  try {
    return await axios.post(
      // `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getMasterAccounts=1`,
      `${BASE_URL}/GetOnlinePaymentReconsileAPI1.php`,
      formData,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving fee configuration form data', err.message) // Handle errors
  }
}
export const approveTransactions = async (gateway_type, fdate, tdate, selected_transaction) => {
  console.log({
    gateway_type,
    fdate,
    tdate,
    selected_transaction,
  })
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const formData = new FormData()
  formData.append('gateway_type', gateway_type)
  formData.append('selected_transaction', selected_transaction)
  formData.append('fdate', fdate)
  formData.append('tdate', tdate)

  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)
  formData.append('is_acknowledgement_submit', 1)
  try {
    return await axios.post(
      // `${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getMasterAccounts=1`,
      `${BASE_URL}/GetOnlinePaymentReconsileAPI1.php`,
      formData,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while saving fee configuration form data', err.message) // Handle errors
  }
}
export const getStudentDetailsByNameSessionNew = async (stud_data, session) => {

  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  const formData = new FormData()
  formData.append('get_stud_details_by_name_session_New', 1)
  formData.append('search_type', 2)
  formData.append('stud_data', stud_data)
  formData.append('session', session)

  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)
  try {
    return await axios.post(
      `${BASE_URL}/FeeControlNew_1.php`,
      formData,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while gettiing student details', err.message) // Handle errors
  }
}

export const getDropoutStudents = async (classId, secId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?getDropOutStudents=1&class=${classId}&sec_id=${secId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting dropout students', err.message)
  }
}

export const updateDropoutStudents = async (student_id, session, remarks) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?updateDropOutStudents=1&student_id=${student_id}&stud_session=${session}&remarks=${remarks}&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while updating dropout students', err.message)
  }
}

export const updateResumeStudents = async (student_id, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${schoolCode}&loginId=${loginId}&resumeDropOutStudent=1&student_id=${student_id}&stud_session=${session}`)
  } catch (err) {
    console.log('Error while updating resumed students', err.message)
  }
}

export const addFeeHeadMapping = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formData.append('schoolCode', schoolCode)
  formData.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php`, formData)
  } catch (error) {
    console.log('Error while adding fee head mapping', error.message)
    throw error
  }
}

export const getFeeHeadMappingTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getSystemFeeHeadMappingTable=1`)
  } catch (error) {
    console.log('Error while adding fee head mapping', error.message)
    throw error
  }
}

export const getCollectPermissionTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getstaffPermissionTable=1`)
  } catch (error) {
    console.log('Error while adding fee head mapping', error.message)
    throw error
  }
}

export const deleteFeeHead = async (id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${schoolCode}&loginId=${loginId}&deleteFeeHead=1&fee_head_id=${id}`)
  } catch (error) {
    console.log('Error while deleting fee head mapping', error.message)
    throw error
  }
}

export const getMasterTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getMasterAccounts=1`)
  } catch (error) {
    console.log('Error while getting master account table Data', error.message)
    throw error
  }
}

export const getAllBankListTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getBankTable=1`)
  } catch (error) {
    console.log('Error while getting bank table ', error.message)
    throw error
  }
}

export const createBank = async (Data) => {
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while adding Bank Name', err.message)
  }
}

export const updateBank = async (Data) => {
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while updating Bank Name', err.message)
  }
}

export const getPayModeTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getPayModeMap=1`)
  } catch (error) {
    console.log('Error while getting paymode table data', error.message)
    throw error
  }
}

export const addPayMode = async (Data) => {
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while adding Pay mode', err.message)
  }
}

export const getallCluster = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getAllClusters=1`)
  } catch (error) {
    console.log('Error while getting cluster table data', error.message)
    throw error
  }
}

export const getOnDemandFeeHeadTableData = async (clusterName, selectedSession) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getODFeeHeadMAp=1&feeClusterName=${clusterName}&selectedSession=${selectedSession}`)
  } catch (error) {
    console.log('Error while getting fee head table data', error.message)
    throw error
  }
}

export const getAllFeeHead = async (session, feeType) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/api-controller/Fees/getFeesData.php?loginId=${loginId}&schoolCode=${schoolCode}&getFeeHeadBySessionAndType=1&session=${session}&feeType=${feeType}`)
  } catch (error) {
    console.log('Error while getting fee heads', error.message)
    throw error
  }
}

export const updateGroup = async (Data) => {
  try {
    return await axios.post(`${BASE_URL}/api-controller/Fees/getFeesData.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while adding on demand fee head map', err.message)
  }
}

export const getFeeCollectionGroupMapTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/FeeCollectionGroupMap_Api.php?get_table_data=1&fee_type_table=1&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting table Data', err.message)
  }
}

export const addFeeCollectionGroup = async (Data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  Data.append('schoolCode', schoolCode)
  Data.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/FeeCollectionGroupMap_Api.php?`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while adding on fee collection group type', err.message)
  }
}

export const deleteGroup = async (Data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  Data.append('schoolCode', schoolCode)
  Data.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/FeeCollectionGroupMap_Api.php?`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while deleting on fee collection group type', err.message)
  }
}

export const updateFeeGroup = async (Data, id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  Data.append('schoolCode', schoolCode)
  Data.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/FeeCollectionGroupMap_Api.php?id=${id}`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while updating on fee collection group type', err.message)
  }
}

export const getallConcessions = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/FeeControlNew_1.php?get_all_consessions=1&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting table Data', err.message)
  }
}

export const getFeeHeadsByType = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/FeeControlNew_1.php?get_head_by_fee_type=1&session=${session}&fee_type[]=Regular&fee_type[]=Hostel&fee_type[]=OD_Group&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting table Data', err.message)
  }
}

export const deleteFeeConcession = async (Data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  Data.append('schoolCode', schoolCode)
  Data.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/FeeControlNew_1.php?`, Data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while updating on fee concession ', err.message)
  }
}

export const getMonthWiseFeeData = async (session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/Monthly_Attendance_Options.php?session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting table Data', err.message)
  }
}

export const getLateFineTableData = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/LateFee_2New.php?table_body=1`)
  } catch (err) {
    console.log('Error while getting table Data', err.message)
  }
}


export const saveLateFeeConfig = async (fd) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  fd.append('schoolCode', schoolCode)
  fd.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/LateFee_2New.php?`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while updating on fee concession ', err.message)
  }
}

export const updateLateFine = async (fd) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  fd.append('schoolCode', schoolCode)
  fd.append('loginId', loginId)
  try {
    return await axios.post(`${BASE_URL}/LateFee_2New.php?`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while updating on fee concession ', err.message)
  }
}

export const getClusterDetailsService = async (clusterName, session, structureType , student_id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/Fees/getFeesData.php?getClusterDetailsService=1&cluster_name=${clusterName}&cluster_session=${session}&structure_type=${structureType}&student_id=${student_id}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.log('Error while checking existing fees', err.message)
  }
}

export const getStructureTableData = async (clusterId, structureType ,session ) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/FeeControlNew_1.php?get_cluster_form=1&cluster_Id=${clusterId}&structure_type=${structureType}&cluster_session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.log('Error while checking existing fees', err.message)
  }
}

export const getMasterAccount = async (clusterId ,session, structureType ) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/FeeControlNew_1.php?get_clust_details=1&cluster_name=${clusterId}&structure_type=${structureType}&cluster_session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`,
    )
  } catch (err) {
    console.log('Error while checking existing fees', err.message)
  }
}

export const updatePostFeeStructure = async (data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  data.append('schoolCode', schoolCode)
  data.append('loginId', loginId)
  data.append('responseType','JSON')
  try {
    return await axios.post(`${BASE_URL}/FeeStructurePosting_2.php?`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  } catch (err) {
    console.log('Error while posting on fee structure ', err.message)
  }
}

export const checkFeeDetails = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/FeeControlNew_1.php?check_fee_exists=get_details&student_id=${studentId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while checking fee exists', err.message)
  }
}

export const getFeeChangeDetails = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/FeeControlNew_1.php?get_Student_fee=get_fee_change_details&responseType=JSON&student_id=${studentId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting fee change details', err.message)
  }
}

export const getFeeDisplayDetails = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(`${BASE_URL}/FeeControlNew_1.php?display_indv_stud_fee=display_record&responseType=JSON&student_id=${studentId}&session=${session}&schoolCode=${schoolCode}&loginId=${loginId}`)
  } catch (err) {
    console.log('Error while getting fee details', err.message)
  }
}

export const updateIndvFeeRecord = async (data) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  data.append('schoolCode', schoolCode)
  data.append('loginId', loginId)
  data.append('responseType','JSON')
  try {
    return await axios.post(`${BASE_URL}/FeeControlNew_1.php`,data)
  } catch (err) {
    console.log('Error while getting fee details', err.message)
  }
}